import React from 'react';
import { Badge } from '../ui';
import { FieldInfo } from '../../models';

interface FieldChipsProps {
  field: FieldInfo;
}

const FieldChips: React.FC<FieldChipsProps> = ({ field }) => {
  return (
    <div className="flex flex-wrap gap-2 items-center">
      {field.multiple && (
        <Badge variant="primary" size="sm">
          Multiple
        </Badge>
      )}
      {field.complex && (
        <Badge variant="secondary" size="sm">
          Complex
        </Badge>
      )}
      {field.type === 'valueList' && (
        <Badge variant="info" size="sm">
          Value List
        </Badge>
      )}
      {field.required && (
        <Badge variant="error" size="sm">
          Required
        </Badge>
      )}
    </div>
  );
};

export default FieldChips;
